var map = {
	"./baner-1.webp": 467,
	"./baner-10.webp": 468,
	"./baner-11.webp": 450,
	"./baner-12.webp": 469,
	"./baner-13.webp": 470,
	"./baner-14.webp": 471,
	"./baner-2.webp": 472,
	"./baner-3.webp": 473,
	"./baner-4.webp": 474,
	"./baner-5.webp": 475,
	"./baner-6.webp": 476,
	"./baner-61.webp": 477,
	"./baner-7.webp": 478,
	"./baner-8.webp": 479,
	"./baner-9.webp": 480
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 466;